var map = {
	"./active-checkbox.svg": "./src/images/active-checkbox.svg?4b74",
	"./add-cross.svg": "./src/images/add-cross.svg",
	"./add-icon-active.svg": "./src/images/add-icon-active.svg",
	"./add-icon.svg": "./src/images/add-icon.svg",
	"./added-icon.svg": "./src/images/added-icon.svg",
	"./airplane.svg": "./src/images/airplane.svg",
	"./arrow-back.svg": "./src/images/arrow-back.svg",
	"./arrow-drop-down.svg": "./src/images/arrow-drop-down.svg",
	"./arrow-forward.svg": "./src/images/arrow-forward.svg",
	"./arrow-show-less.svg": "./src/images/arrow-show-less.svg",
	"./arrow-show-more.svg": "./src/images/arrow-show-more.svg",
	"./avatar.png": "./src/images/avatar.png",
	"./avatar.svg": "./src/images/avatar.svg",
	"./box-registration.svg": "./src/images/box-registration.svg",
	"./burger-menu-button.svg": "./src/images/burger-menu-button.svg",
	"./bus.svg": "./src/images/bus.svg",
	"./car.svg": "./src/images/car.svg",
	"./catalog.svg": "./src/images/catalog.svg",
	"./check-icon.svg": "./src/images/check-icon.svg",
	"./close-button.svg": "./src/images/close-button.svg",
	"./close-icon.svg": "./src/images/close-icon.svg",
	"./cloud-download-blue.svg": "./src/images/cloud-download-blue.svg",
	"./cloud-download.svg": "./src/images/cloud-download.svg",
	"./cross.svg": "./src/images/cross.svg",
	"./disabled-checkbox.svg": "./src/images/disabled-checkbox.svg?8b9e",
	"./download-success.svg": "./src/images/download-success.svg",
	"./edit-icon.svg": "./src/images/edit-icon.svg",
	"./exit-icon-white.svg": "./src/images/exit-icon-white.svg",
	"./exit-icon.svg": "./src/images/exit-icon.svg",
	"./filter-icon.svg": "./src/images/filter-icon.svg",
	"./fixation-history.svg": "./src/images/fixation-history.svg",
	"./fixation.svg": "./src/images/fixation.svg",
	"./list-icon.svg": "./src/images/list-icon.svg",
	"./logo.svg": "./src/images/logo.svg",
	"./map-icon.svg": "./src/images/map-icon.svg",
	"./profile-icon.svg": "./src/images/profile-icon.svg",
	"./radio-active.svg": "./src/images/radio-active.svg",
	"./radio-disabled.svg": "./src/images/radio-disabled.svg",
	"./remove-button.svg": "./src/images/remove-button.svg",
	"./right-arrow.svg": "./src/images/right-arrow.svg",
	"./search.svg": "./src/images/search.svg",
	"./select-active.svg": "./src/images/select-active.svg?ed0d",
	"./select-disabled.svg": "./src/images/select-disabled.svg?f258",
	"./success-icon.svg": "./src/images/success-icon.svg",
	"./temperature-line.svg": "./src/images/temperature-line.svg",
	"./tracking.svg": "./src/images/tracking.svg",
	"./train.svg": "./src/images/train.svg",
	"./users.svg": "./src/images/users.svg",
	"./view-img-active.svg": "./src/images/view-img-active.svg",
	"./view-img.svg": "./src/images/view-img.svg",
	"./view-list-active.svg": "./src/images/view-list-active.svg",
	"./view-list.svg": "./src/images/view-list.svg",
	"./visibility-icon.svg": "./src/images/visibility-icon.svg?ac4b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images sync recursive ^\\.\\/.*$";